import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PLESSI, fmt } from "./utils";
import { VocePicker } from "./VocePicker";

export function RigheTable({ righe, onDeleteAll, totale, idDoc, onChanged }) {
  const tot = righe.reduce((s, r) => s + (Number(r.importo) || 0), 0);
  const delta = (Number(totale) || 0) - tot;
  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState({ conto: "", plesso: "", importo: 0 });
  const [voci, setVoci] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [quickPickRiga, setQuickPickRiga] = useState(null);
  useEffect(() => {
    if ((editingId || quickPickRiga) && voci.length === 0) {
      api.get("/pn/bilancio-voci", { params: { foglie: true } }).then(r => setVoci(r.data.data || []));
    }
  }, [editingId, quickPickRiga, voci.length]);

  const startEdit = (r) => { setEditingId(r.riga_id); setDraft({ conto: r.conto, plesso: r.plesso || "INFANZIA", importo: r.importo }); };
  const cancelEdit = () => { setEditingId(null); };

  const saveEdit = async () => {
    if (!draft.conto || draft.importo == null) return;
    await api.put(`/pn/fatture/${idDoc}/righe/${editingId}`, {
      conto: Number(draft.conto), plesso: draft.plesso, importo: Number(draft.importo),
    });
    setEditingId(null);
    if (onChanged) await onChanged();
  };

  const deleteOne = async (r) => {
    if (!window.confirm(`Eliminare la riga ${r.plesso} - conto ${r.conto} (€ ${fmt(r.importo)})?`)) return;
    await api.delete(`/pn/fatture/${idDoc}/righe/${r.riga_id}`);
    if (onChanged) await onChanged();
  };

  const handleQuickPick = async (voce) => {
    if (!quickPickRiga) return;
    await api.put(`/pn/fatture/${idDoc}/righe/${quickPickRiga.riga_id}`, {
      conto: Number(voce.id_conto), plesso: quickPickRiga.plesso || "INFANZIA", importo: Number(quickPickRiga.importo || 0),
    });
    setQuickPickRiga(null);
    if (onChanged) await onChanged();
  };

  const voceSel = voci.find(v => v.id_conto === Number(draft.conto));

  return (
    <>
    <table className="sw-table sw-table-compact" style={{ fontSize: 11 }}>
      <thead style={{ background: "#37474f", color: "white", position: "sticky", top: 0 }}>
        <tr>
          <th style={{ width: 32 }}>#</th>
          <th style={{ width: 120 }}>SETTORE</th>
          <th style={{ width: 60, textAlign: "center" }}>CONTO</th>
          <th>VOCE BILANCIO</th>
          <th style={{ width: 110, textAlign: "right" }}>IMPORTO €</th>
          <th style={{ width: 90, textAlign: "center" }}>AZIONI</th>
        </tr>
      </thead>
      <tbody>
        {righe.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessuna riga. Usa <b>+ Riga</b> o <b>⚡ RIPARTO</b>.</td></tr>}
        {righe.map((r, i) => {
          const isEditing = editingId === r.riga_id;
          const orphan = !r.descrizione_conto;
          return (
            <tr key={r.riga_id || i} data-testid={`pn-fat-riga-${i}`}>
              <td style={{ textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i+1}</td>
              {isEditing ? (
                <>
                  <td>
                    <select value={draft.plesso} onChange={e => setDraft(d => ({ ...d, plesso: e.target.value }))} data-testid={`pn-fat-riga-edit-plesso-${i}`}
                      style={{ width: "100%", padding: "2px 4px", fontSize: 11 }}>
                      {PLESSI.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <button onClick={() => setPickerOpen(true)} data-testid={`pn-fat-riga-edit-conto-${i}`}
                      style={{ padding: "2px 8px", background: draft.conto ? "#0d47a1" : "#bbb", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "monospace" }}>
                      {draft.conto || "?"} 🌲
                    </button>
                  </td>
                  <td style={{ fontSize: 10, color: "#555" }}>
                    {voceSel ? <span><b>{voceSel.descrizione}</b></span> : <span style={{ color: "#bbb" }}>clicca conto per selezionare</span>}
                  </td>
                  <td>
                    <input type="number" step="0.01" value={draft.importo} onChange={e => setDraft(d => ({ ...d, importo: e.target.value }))} data-testid={`pn-fat-riga-edit-importo-${i}`}
                      style={{ width: "100%", padding: "2px 4px", fontSize: 11, fontFamily: "monospace", textAlign: "right" }} />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <button onClick={saveEdit} data-testid={`pn-fat-riga-save-${i}`}
                      style={{ padding: "2px 6px", background: "#1b5e20", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 2 }}>✓</button>
                    <button onClick={cancelEdit}
                      style={{ padding: "2px 6px", background: "white", color: "#555", border: "1px solid #888", fontSize: 10, cursor: "pointer" }}>✕</button>
                  </td>
                </>
              ) : (
                <>
                  <td style={{ fontWeight: 700, color: "#0d47a1" }}>{r.plesso || "—"}</td>
                  <td style={{ textAlign: "center", fontFamily: "monospace", color: orphan ? "#c62828" : "#0d47a1", fontWeight: 700 }}>{r.conto}</td>
                  <td onClick={() => setQuickPickRiga(r)} data-testid={`pn-fat-riga-voce-${i}`}
                    title="Clicca per cambiare la voce di bilancio"
                    style={{ cursor: "pointer", color: orphan ? "#c62828" : "#0d47a1", textDecoration: "underline", textDecorationStyle: "dotted", fontWeight: orphan ? 700 : 400 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#e3f2fd"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                    {orphan ? `⚠ Conto ${r.conto} non presente nel piano dei conti — clicca per associare` : r.descrizione_conto}
                  </td>
                  <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{fmt(r.importo)}</td>
                  <td style={{ textAlign: "center" }}>
                    <button onClick={() => startEdit(r)} data-testid={`pn-fat-riga-edit-${i}`}
                      style={{ padding: "2px 6px", background: "#1565c0", color: "white", border: "none", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 2 }}>✏</button>
                    <button onClick={() => deleteOne(r)} data-testid={`pn-fat-riga-del-${i}`}
                      style={{ padding: "2px 6px", background: "white", color: "#c62828", border: "1px solid #c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                  </td>
                </>
              )}
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr style={{ background: "#fff8e1", fontWeight: 700 }}>
          <td colSpan={4} style={{ textAlign: "right", padding: "5px 8px" }}>Σ Righe</td>
          <td style={{ textAlign: "right", fontFamily: "monospace" }}>{fmt(tot)}</td>
          <td />
        </tr>
        {Math.abs(delta) > 0.01 && (
          <tr style={{ background: "#ffebee", fontWeight: 700, color: "#c62828" }}>
            <td colSpan={4} style={{ textAlign: "right", padding: "5px 8px" }}>Δ vs totale fattura</td>
            <td style={{ textAlign: "right", fontFamily: "monospace" }}>{fmt(delta)}</td>
            <td />
          </tr>
        )}
        {righe.length > 0 && (
          <tr>
            <td colSpan={6} style={{ textAlign: "right", padding: 6 }}>
              <button onClick={onDeleteAll} style={{ padding: "3px 10px", background: "white", border: "1px solid #c62828", color: "#c62828", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑 Cancella tutte</button>
            </td>
          </tr>
        )}
      </tfoot>
    </table>
    <VocePicker open={pickerOpen} value={draft.conto} onClose={() => setPickerOpen(false)} onSelect={v => { setDraft(d => ({ ...d, conto: v.id_conto })); setPickerOpen(false); if (!voci.find(x => x.id_conto === v.id_conto)) setVoci(prev => [...prev, v]); }} />
    <VocePicker open={!!quickPickRiga} value={quickPickRiga?.conto} onClose={() => setQuickPickRiga(null)} onSelect={handleQuickPick} />
    </>
  );
}
